import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-merchant-reject-modal',
  templateUrl: './merchant-reject-modal.component.html',
  styleUrls: ['./merchant-reject-modal.component.scss'],
})
export class MerchantRejectModalComponent {
  comment?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { multiple: boolean }
  ) {}
}
